Ext.define('SA.view.TextField', {
    alias: 'widget.sa-textfield',
    extend: 'Ext.form.field.Text',

    enforceMaxLength: true,
    maxLength: 96,

    isFocused() {
        return this.inputEl && this.inputEl.dom === document.activeElement;
    }
});